require('./ctxWidgetPanel.style.scss');

class CtxWidgetPanelController {
    constructor($element, $state) {
        this._$element = $element;
        this.$state = $state;
        // if (angular.isDefined(this.maxHeightInPx)) {
        //     let bodyHeight = this.maxHeightInPx - this._$element.find('.panel-body').prop('offsetHeight') - 33;
        //     this._$element.find('.panel-body').css('max-height', bodyHeight);
        // }
        // if (angular.isDefined(this.minHeight)) {
        //     let bodyHeight = this.minHeight - this._$element.find('.panel-body').prop('offsetHeight') - 33;
        //     this._$element.find('.panel-body').css('min-height', bodyHeight);
        //     this._$element.find('.panel-body').css('height', bodyHeight);
        // }
    }

    changeState() {
        if (this.state) {
            this.$state.go(this.state);
        }
    }
}

const ctxWidgetPanelComponent = {
    restrict: 'E',
    controller: CtxWidgetPanelController,
    transclude: {
        'main': '?mainSlot',
        'details': '?detailsSlot'
    },
    template: require('./ctxWidgetPanel.template.html'),
    bindings: {
        widgetTitle: '@?',
        widgetTitleTooltip: '@?',
        widgetSubTitle: '@?',
        widgetDragIcon: '<?',
        widgetSlotSeparator: '<?',
        customScroll: '<?',
        state: '@?',
        cursorPointer: '<'
    }
};

CtxWidgetPanelController.$inject = ['$element', '$state'];

module.exports = ctxWidgetPanelComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxWidgetPanel/ctxWidgetPanel.component.js